import {
  LOGGED_OUT,
  LOGGED_IN,
  FETCH_INFO,
  USER_MODIFY,
  RESET_MEMBER
} from '../actions/types';

const INITIAL_STATE = {
  isLogin: false,
  editProfile:false,
  dashboardLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGGED_IN:
      return { ...state, isLogin: true, ...action.payload };
    case LOGGED_OUT:
      return { ...state, isLogin: false };
    case FETCH_INFO:
      return {
        ...state,
        dashboardLoading:true,
        ...action.payload
      };
    case USER_MODIFY:
      return {
        ...state,
        editProfile: action.payload
      }
    case RESET_MEMBER:
      return {
      isLogin: false
      }
    default:
      return state;
  }
};
